import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">📅 Mes: {label}</Typography>
      {payload.map(({ name, value, color }, idx) => (
        <Typography key={idx} variant="body2" sx={{ color }}>
          🏪 {name}: {formatMoney(value)}
        </Typography>
      ))}
    </Box>
  );
};

const BranchMonthlyGrowthChart = ({ data, branches, loading }) => {
  if (loading) {
    return (
      <Paper elevation={2} sx={{ p: 2, height: 340 }}>
        <Typography variant="subtitle1" gutterBottom>
          Crecimiento mensual por sucursal
        </Typography>
        <Skeleton variant="rectangular" height={300} />
      </Paper>
    );
  }

  return (
    <Paper elevation={2} sx={{ p: 2, height: 340 }}>
      <Typography variant="subtitle1" gutterBottom>
        Crecimiento mensual por sucursal
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          {branches.map(branch => (
            <Line
              key={branch.id}
              type="monotone"
              dataKey={branch.id.toString()}
              name={branch.name}
              stroke={branch.color}
              strokeWidth={2}
              dot={{ r: 3 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default BranchMonthlyGrowthChart;
